import UserProfileMenuLinks from '@/creditflowresearch/ui/common/components/organisms/UserProfileMenuLinks/UserProfileMenuLinks';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';

import styles from './userProfileMenuTemplate.module.scss';

interface IUserProfileMenuTemplateProps {
  children: React.ReactNode,
  onClose?: () => void,
}

const UserProfileMenuTemplate = ({ children, onClose }: IUserProfileMenuTemplateProps) => {
  const { checkAccessByUserPlan } = useUserPlanContext();

  return (
    <div
      data-test="userProfileMenuTemplate"
      className={ styles.profileDropdownContent }
    >
      <CheckUserAccess
        conditions={ [
          {
            checks: [checkAccessByUserPlan(UserPlanType.STARTER)],
          },
        ] }
      >
        { children }
      </CheckUserAccess>
      <UserProfileMenuLinks onClose={ onClose } />
    </div>
  );
};

export default UserProfileMenuTemplate;
